import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { Subscription } from 'rxjs';
import { AggregationService } from 'src/app/_services/aggregation.service';
import { CompanyInsightsService } from 'src/app/_services/company-insights.service';
import { FilterDataHandlerService } from 'src/app/_services/filter-data-handler.service';
import { LocalStorageService } from 'src/app/_services/local-storage.service';
import { PersonSearchService } from 'src/app/_services/person-search.service';

@Component({
    selector: 'app-similar-companies',
    templateUrl: './similar-companies.component.html',
    styleUrls: ['./similar-companies.component.scss'],
    standalone: false
})
export class SimilarCompaniesComponent implements OnInit {
  companyId: any;
  companyDetails:any;
  companyData:any;
  similarCompanies: any[] = [];
  alternatecompanyNames: string[] = [];
  start: number = 0;
  aggregateCount: number = 9;
  subscriptions: Subscription[] = [];
  showSimilarCompaniesLoader: boolean = false;
  constructor(private companyInsightsService: CompanyInsightsService,private router: Router,
      private activatedRoute: ActivatedRoute, private aggService: AggregationService, private personSearchService: PersonSearchService,
      private localStorageService: LocalStorageService, private filterDataHandlerService: FilterDataHandlerService) { }

  ngOnInit() {
    this.companyData = this.companyInsightsService.fetchCompanyData;
    this.alternatecompanyNames = this.companyData?.alternative_names?.length > 0 ? this.companyData.alternative_names.concat([this.companyData.name]) : [this.companyData.name];
    this.companyId = this.companyData.id;
    this.fetchPageData();
      const filterMethodEvent = this.filterDataHandlerService.filterMethodEvent.subscribe(_methodDetails => this.fetchPageData());
    this.subscriptions.push(filterMethodEvent);

  }

  fetchPageData() {
    this.start = 0;
    this.aggregateCount = 9;
    this.getSimilarCompanies();
  }

  getSimilarCompanies() {
    this.similarCompanies = [];
    this.showSimilarCompaniesLoader = true;
    const localRequestObject = this.aggService.getRequestWithFilters();
    localRequestObject.startindex = this.start;
    localRequestObject.companies = this.alternatecompanyNames;
    localRequestObject.functiontype = 'Current';
    localRequestObject.companyids = [this.companyId];
    localRequestObject.aggregatescount = this.aggregateCount;
    delete localRequestObject.aggregatetype;
    this.companyInsightsService.getSimilarCompanies(localRequestObject).subscribe((response) => {
      this.showSimilarCompaniesLoader = false;
      if (response && response.status === 'success') {
        const result =  response.similarCompanies;
       this.similarCompanies =result;

      }
    });
  }

  openCompanyCompare(company) {
    this.localStorageService.setItem('companyOneId', company.id);
    this.localStorageService.setItem('companyTwoId', this.companyId);
    const url = "/company-compare";
    window.open(url, "_blank");
  }

  openViewInsights(company) {
        this.localStorageService.setItem('companyCurrency', 'USD')

    const url = `/company-details/${company.id}`;
    window.open(url, "_blank");
  }

  openViewMoreSimilarCompanies() {
    this.start = this.start + 1;
    this.aggregateCount = this.aggregateCount + 3;
    this.getSimilarCompanies();
  }

}
